import { ActionTree } from 'vuex';
import ApiUrl from '../../../../api/url';
import { LendingRecordState } from './types';
import { RootState } from '../../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../../error-type';

export const actions: ActionTree<LendingRecordState, RootState> = {
    /**
     * 申請書紐付き特権ID貸出記録一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} id 申請書ID
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @param {any} word 検索文字列
     * @returns {Promise<void>}
     */
    async search({ dispatch, commit }, { id, pageNumber, perPage, sort, searchItems = {} } = {}) {
        const payload = {
            start_date: searchItems.startDate,
            end_date: searchItems.endDate,
            word: searchItems.word,
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.SEARCH_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.ApplicationForm.PrivilegedIdLendingRecord.INDEX.replace(':id', id),
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SEARCH_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.SEARCH_FAILURE, params);
        }
    },
};
